<template>
  <component
    :is="slide.menu_url && isStandalone ? NuxtLink : 'div'"
    :to="localePath(slide.menu_url)"
    class="mx-auto block w-full transition-colors duration-100 sm:max-w-110 md:max-w-182 lg:max-w-214.5 xl:max-w-281.25 2xl:max-w-331.25"
    :class="[
      isStandalone
        ? 'px-5 pt-5 pb-10 md:px-7.5 md:pt-7.5 md:pb-22.5 xl:px-12.5 xl:pt-10 xl:pb-25 2xl:pt-12.5 2xl:pb-28.75'
        : '',
      slide.slug?.[locale] && isStandalone ? 'cursor-pointer' : '',
    ]"
    :style="[
      {
        backgroundColor:
          slide.background &&
          slide.background !== 'white' &&
          slide.background !== '#ffffff' &&
          slide.background !== 'ffffff'
            ? slide.background.startsWith('#')
              ? slide.background
              : `#${slide.background}`
            : '#CDB946',
      },
    ]"
  >
    <div :class="['relative', { 'mx-auto max-w-360': isStandalone }]">
      <div
        v-if="isStandalone"
        class="mb-10 flex w-full items-center justify-center gap-0.5 md:justify-between md:gap-0 2xl:mb-11.75"
      >
        <div class="hidden md:block">
          <TypeBadge
            v-if="displayType"
            :text="displayType"
            class="py-1.5 leading-[110%] xl:text-[17px]"
          />
        </div>

        <div
          class="text-sm leading-[120%] md:absolute md:top-0 md:left-1/2 md:z-20 md:-translate-x-1/2 md:text-[17px] xl:absolute xl:text-xl 2xl:text-[23px]/[29px]"
        >
          {{ formattedDate }}
        </div>
      </div>

      <div
        class="group bp1440-event-img bp1680-event-img mx-auto flex h-full w-full max-w-[82%] flex-col items-center sm:max-w-72.5 md:max-w-[71.5%] lg:max-w-131.5"
      >
        <h2
          :data-slider-title="
            !isStandalone && titleGroupId ? titleGroupId : undefined
          "
          :style="
            !isStandalone && titleGroupId && fixedHeight
              ? { height: fixedHeight }
              : {}
          "
          class="mb-5 line-clamp-5 text-center font-header text-[22px] leading-[1.15] font-normal text-pretty md:text-2.5xl xl:mb-7.5 xl:text-4.5xl/[42px] 2xl:text-[47px]/[49px]"
        >
          {{ slide.title }}
        </h2>

        <TypeBadge
          v-if="displayType"
          :text="displayType"
          class="mb-7.5 rounded-md py-1 text-xs leading-none md:hidden xl:px-6 xl:py-2"
        />

        <div
          :class="[
            'bp1680:shadow-[0_6px_6px_rgba(0,0,0,0.25)] block aspect-6/4 w-full origin-center overflow-hidden shadow-[0_5px_5px_rgba(0,0,0,0.25)] transition-transform duration-300 ease-out sm:shadow-[0_6.17px_6.17px_rgba(0,0,0,0.25)] md:shadow-[0_5px_5px_rgba(0,0,0,0.25)] 2xl:shadow-[0_6px_6px_rgba(0,0,0,0.25)]',
            {
              'group-hover:scale-[1.03]': slide.slug?.[locale],
            },
          ]"
        >
          <NuxtImg
            :src="displayImage"
            :alt="slide.title"
            format="webp"
            sizes="xs:90vw sm:290px md:520px lg:530px xl:650px"
            class="block h-full w-full object-cover object-center"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import { NuxtLink } from '#components'
import type { AppEvent } from '~/types'

interface Props {
  slide: AppEvent
  titleGroupId?: string
  fixedHeight?: string
  isStandalone?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isStandalone: true,
})

const { locale } = useI18n()
const localePath = useLocalePath()

const displayType = computed(() => {
  return (
    props.slide?.type ||
    props.slide?.eventTags?.map((tag: any) => tag.name).join(', ') ||
    ''
  )
})

const displayImage = computed(() => {
  return (
    props.slide?.image ||
    props.slide?.featuredImage?.[0]?.url ||
    props.slide?.featured_image?.[0] ||
    'https://placehold.co/600x400'
  )
})

const formattedDate = useFormattedDate(
  () => props.slide?.starts_at,
  () => props.slide?.ends_at,
)
</script>
